<template>
    <header class="fd-headers">
        <div class="fd-logo-box">
            <img @click="toHref('https://wfcc.info/')" src="../../images/common/wfcc.png" alt="">
            <img @click="toHref('https://worlddatasystem.org/')" src="../../images/common/1.png" alt="">
            <img @click="toHref('http://anso.org.cn/ch/')" src="../../images/common/2.png" alt="">
            <!-- <img @click="toHref('https://www.unesco.org/en')" src="../../images/common/3.png" alt=""> -->
            <img src="../../images/common/4.png" alt="">
        </div>
        <ul>
            <li v-for="(item,index) in navList" @click="navClick(item)" :class="active == item.label?'active':''" :key="index+'nav'">{{item.label}}</li>
        </ul>
    </header>
</template>
<script>
export default {
  data () {
    return {
      navList: [
        {
          label: 'Home',
          path: '/'
        },
          {
              label: 'History',
              path: '/history'
          },
        {
          label: 'Training couses',
          path: '/trainingcouses'
        },
        {
          label: 'Events',
          path: '/event'
        },
        {
          label: 'WDCM News',
          path: '/news'
        },
        {
          label: 'Cooperation',
          path: '/cooperation'
        },

        {
          label: 'Projects',
          path: '/projects'
        }
      ],
      active: 'Training couses'
    };
  },
  watch: {
    $route () {
      this.active = this.$route.meta.nav;
    }
  },
  created () {
    this.active = this.$route.meta.nav;
  },
  methods: {
    toHref (href) {
      window.open(href, '_blank');
    },
    navClick (item) {
      this.active = item.label;
      this.$router.push({
        path: item.path
      });
    }
  }
};
</script>
<style lang="less">
.fd-headers {
    height: 100px;
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .fd-logo-box {
        height: 100px;
        display: flex;
        align-items: center;
        img {
            height: 52px;
            margin-right: 10px;
            cursor: pointer;
        }
    }
    > ul {
        display: flex;
        height: 100%;
        align-items: center;
        margin-left:45px;
        li {
            color: #4c4c4c;
            margin-right: 40px;
            font-weight: bold;
            line-height: 97px;
            border-bottom: 3px solid transparent;
            cursor: pointer;
            font-size: 18px;
        }
        li:nth-last-child(1) {
            margin-right: 0;
        }
        .active {
            color: #003996;
            border-bottom: 3px solid #003996;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/headers.vue